var request = require('./request');
var Promise = require('bluebird');
var config = require('./config');
var resolve = require('./resolve');

exports.GetRepoToken = function(id, userCanCreateDocs) {
	return request.get(resolve(config.url(), 'repository/token?id=' + id + "&userCanCreateDocs=" + userCanCreateDocs)).promise();
}
